import React from "react";
import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import { RadioButtonCustom, RadioGroupCustom } from "./styles";

const GroupFarmSelector = ({
  value,
  onChange,
  disabled = false,
  translationKey = "groupFarmVisibility",
  showGroupName = true,
}) => {
  const { translation, groupSelected } = useSelector((state) => state.app);

  // Função para obter a tradução baseada na chave fornecida
  const getTranslation = (key) => {
    const keys = key.split(".");
    let result = translation;

    for (const k of keys) {
      if (result && result[k]) {
        result = result[k];
      } else {
        return `Translation not found: ${key}`;
      }
    }

    return result;
  };

  return (
    <Row type="flex" align="middle">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Row>
          <label>{getTranslation(translationKey)}</label>
        </Row>
        <Row>
          <RadioGroupCustom
            value={value}
            buttonStyle="solid"
            onChange={onChange}
          >
            <RadioButtonCustom value="farm" disabled={disabled}>
              {translation.supplier.form.radiogroup.farm}
            </RadioButtonCustom>
            <RadioButtonCustom value="group" disabled={disabled}>
              {translation.supplement.form.radiogroup.group}
              {showGroupName && groupSelected?.name
                ? `: ${groupSelected.name}`
                : ""}
            </RadioButtonCustom>
          </RadioGroupCustom>
        </Row>
      </Col>
    </Row>
  );
};

export default GroupFarmSelector;
